import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { getEnvVar } from '../../utils/getEnvVar';

export const SepPlansReviewMessage = ({
  sepPlansToReview,
  showSepPlanTabMessage = true
}) => {
  const sepBaseUrl = getEnvVar('VITE_SEP_APP_BASE_URL');

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: (theme) => theme.fuel6Tokens.JddcSpacingXSmall
      }}
    >
      {`SEP Plans to Review (${sepPlansToReview.length})`}
      <Link
        href={`${sepBaseUrl}?planIds=${sepPlansToReview
          .map((plan) => plan.planId)
          .toString()}`}
        target="_blank"
        rel="noopener noreferrer"
        variant="linkExternal"
      >
        Review in SEP
      </Link>
      {showSepPlanTabMessage && (
        <Typography variant="bodyMedium">or View in SEP Plans tab</Typography>
      )}
    </Box>
  );
};
